import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { Box, CircularProgress, Grid } from '../../utils/material-ui-core';

const Wait = () => {
  const pageStyles = LocalPageStyles();

  return (
    <Grid container spacing={0} direction="row" alignContent="center" justifyContent="center">
      <Grid item className={pageStyles.waitContainer}>
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" className={pageStyles.waitContent}>
          <Box p={3}>
            <CircularProgress color="secondary" />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    waitContainer: {
      height: "inherit",
    },
    waitContent: {
      margin: "auto",
      padding: "100px 50px",
      minWidth: "100px",
    },
  })
);

export default Wait;
